import { showFailToast } from 'vant';
import axios from 'axios';
import qs from 'qs';
import Cookies from 'js-cookie';
import envConfig from '@/config';
import { postToken } from '@/utils';

const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];

const instance = axios.create({
  baseURL,
  timeout: 100000,
  paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  },
});

if (envConfig.env === 'development') {
  instance.interceptors.request.use((request) => request);
  instance.interceptors.response.use((response) => {
    console.log(`请求${response.config.url.replace(new RegExp(response.config.baseURL), '')}返回的Mock数据:`);
    console.dir(response.data);
    return response;
  });
}

// 拦截器
instance.interceptors.request.use(
  async (request) => {
    // console.log('安卓打印');
    // console.log(postToken());
    // console.log(window.native);
    // localStorage.setItem('token', JSON.stringify('TK-1635296747-9yriOTR65VTqIl4a3MfjI3AOPbPEZH2g'));
    const token = postToken() || JSON.parse(localStorage.getItem('token') || '""');
    const userId = JSON.parse(localStorage.getItem('userId') || '""');
    Cookies.set('ticket', token);
    Cookies.set('user_id', userId);
    request.withCredentials = true;
    // request.headers['version'] = config.version;
    if (token && !request.headers['Authorization']) {
      request.headers['Authorization'] = token;
      request.headers['applet-token'] = token;
    } else {
      request.headers['Authorization'] = 'YyPhuktDZtOnnaWlOepyBheBWRzWQI3';
      request.headers['applet-token'] = 'YyPhuktDZtOnnaWlOepyBheBWRzWQI3';
    }

    return request;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    // 阻止options
    if (response.config.method.toLowerCase() === 'options') return false;
    const { to } = response.config;
    const meta = (to || {}).meta || {};
    if (response.status !== 200 && meta.auth !== 0) {
      return Promise.reject(response);
    }
    return response.data;
  },
  (error) => {
    const { to } = error.response.config;
    const meta = (to || {}).meta || {};
    if (meta.auth === 0) return Promise.resolve(error.response.data);
    if (error.message.indexOf('code 401') > -1) {
      if (error.response.data && error.response.data.msg) {
        showFailToast(error.response.data.msg);
      } else {
        showFailToast('登录失效，请重新登录');
      }
    } else if (error.message.indexOf('code 404') > -1) {
      showFailToast('数据不存在');
    } else if (error.message.indexOf('timeout of') > -1) {
      showFailToast('请求超时了');
    } else {
      showFailToast('系统繁忙，请稍候再试！');
    }
    return Promise.reject(error);
  }
);

export default instance;
